var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntscheidung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0116437,-1.40284,1.27155,-0.010554,-6.70262,22.4303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.482,10.438C6.507,10.408 6.542,10.39 6.579,10.39C6.617,10.39 6.652,10.408 6.677,10.438C7.043,10.889 8.345,12.487 8.843,13.099C8.878,13.142 8.886,13.203 8.865,13.255C8.844,13.307 8.798,13.34 8.746,13.34C7.856,13.34 5.198,13.34 4.369,13.34C4.325,13.34 4.286,13.311 4.268,13.267C4.25,13.223 4.257,13.171 4.286,13.135C4.761,12.552 6.108,10.898 6.482,10.438Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.92829,-2.31162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.428,3.97C31.596,3.97 39.038,11.068 39.038,19.812C39.038,28.555 31.596,35.653 22.428,35.653C13.261,35.653 5.818,28.555 5.818,19.812C5.818,11.068 13.261,3.97 22.428,3.97ZM22.428,6.643C30.086,6.643 36.365,12.508 36.365,19.812C36.365,27.115 30.086,32.98 22.428,32.98C14.77,32.98 8.492,27.115 8.492,19.812C8.492,12.508 14.77,6.643 22.428,6.643Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.673422,0.739258,-0.284139,-0.258835,34.1037,7.75516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.778,16.842C18.778,15.941 18.497,15.21 18.15,15.21L16.895,15.21C16.549,15.21 16.268,15.941 16.268,16.842L16.268,26.904C16.217,29.876 16.472,31.659 16.895,28.535L18.15,28.535C18.497,28.535 19.356,30.055 18.639,26.8L18.778,16.842Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00140169,0.999999,-0.384357,0.000538751,20.8344,-4.19459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.778,16.842C18.778,15.941 18.497,15.21 18.15,15.21L16.895,15.21C16.549,15.21 16.268,15.941 16.268,16.842L16.268,26.902C16.268,27.803 16.549,28.535 16.895,28.535L18.15,28.535C18.497,28.535 18.778,27.803 18.778,26.902L18.778,16.842ZM17.523,21.909L17.565,21.872L17.523,21.835L17.481,21.872L17.523,21.909Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0116437,-1.40284,-1.27155,-0.010554,41.7026,22.4303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.482,10.438C6.507,10.408 6.542,10.39 6.579,10.39C6.617,10.39 6.652,10.408 6.677,10.438C7.043,10.889 8.345,12.487 8.843,13.099C8.878,13.142 8.886,13.203 8.865,13.255C8.844,13.307 8.798,13.34 8.746,13.34C7.856,13.34 5.198,13.34 4.369,13.34C4.325,13.34 4.286,13.311 4.268,13.267C4.25,13.223 4.257,13.171 4.286,13.135C4.761,12.552 6.108,10.898 6.482,10.438Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,35.0228,0.273794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.778,15.837C18.778,15.491 18.497,15.21 18.15,15.21L16.895,15.21C16.549,15.21 16.268,15.491 16.268,15.837L16.268,27.907C16.268,28.253 16.549,28.535 16.895,28.535L18.15,28.535C18.497,28.535 18.778,28.253 18.778,27.907L18.778,15.837Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.673422,0.739258,0.284139,-0.258835,0.896257,7.75516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.778,16.842C18.778,15.941 18.497,15.21 18.15,15.21L16.895,15.21C16.549,15.21 16.268,15.941 16.268,16.842L16.268,26.904C16.217,29.876 16.472,31.659 16.895,28.535L18.15,28.535C18.497,28.535 19.356,30.055 18.639,26.8L18.778,16.842Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.00140169,0.999999,0.384357,0.000538751,14.1656,-4.19459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.778,16.842C18.778,15.941 18.497,15.21 18.15,15.21L16.895,15.21C16.549,15.21 16.268,15.941 16.268,16.842L16.268,26.902C16.268,27.803 16.549,28.535 16.895,28.535L18.15,28.535C18.497,28.535 18.778,27.803 18.778,26.902L18.778,16.842ZM17.523,21.835L17.565,21.872L17.523,21.909L17.481,21.872L17.523,21.835Z",
    style: {
      fill: "white"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntscheidung);
export default __webpack_public_path__ + "static/media/Entscheidung.faba09bcb35252ebb77b640f1e2a9508.svg";
export { ForwardRef as ReactComponent };